import { useState, useEffect } from "react";

import { setUpConnection } from "./webSocket";

const useWebSocket = webSocketPath => {
    const [connectionIsOpen, setConnectionIsOpen] = useState(false);
    const [connection, setConnection] = useState();
    const [data, setData] = useState(null);

    const openConnection = () => {
        setConnection(setUpConnection()(webSocketPath));
    };

    const closeConnection = () => {
        connection && connection.close();
    };

    const handleMessage = e => {
        setData(JSON.parse(e.data));
    };

    const handleOpen = () => {
        setConnectionIsOpen(true);
    };

    const handleClose = () => {
        setConnectionIsOpen(false);
    };

    useEffect(() => {
        if (connection) {
            connection.addEventListener("open", handleOpen);
            connection.addEventListener("close", handleClose);
            connection.addEventListener("message", handleMessage);
        }

        return () => {
            if (connection) {
                connection.removeEventListener("open", handleOpen);
                connection.removeEventListener("close", handleClose);
                connection.removeEventListener("message", handleMessage);
            }
        };
    }, [connection]);

    return { openConnection, closeConnection, data, connectionIsOpen };
};

export default useWebSocket;
